module.exports = __webpack_public_path__ + "static/media/email_icon.9faeeb3a.svg";